import { QueryClient } from '@tanstack/react-query';

/** Shared TanStack Query client with conservative defaults suited to an ERP. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: 0 },
  },
});
